import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PATHS } from "constants/pathConstants";
import Mixpanel from "utils/mixpanel";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import ListArrowIcon from "assets/images/ListArrowIcon.svg";
import WelcomeHero from ".";

type GettingStartedHeroProps = {};

const GettingStartedHero: React.FC<GettingStartedHeroProps> = () => {
  const history = useHistory();
  const userInformation = useSelector(selectUserPersonalInformation);
  const greetingName =
    userInformation.preferredName ?? userInformation.firstName ?? "";
  const onActionClick = useCallback(() => {
    Mixpanel.track(`To Do Card CTA Clicked - Precision guidance survey`);
    history.push(PATHS.GETTING_STARTED_SURVEY);
  }, [history, Mixpanel, PATHS]);

  return (
    <WelcomeHero
      contentButtonText="Continue"
      contentHeaderText="Continue your journey"
      contentSubTextIcon={`🎉`}
      contentSubText={`Good to see you, ${greetingName}!`}
      contentParagraphText="To request testing appropriate for you or to let us know about a cancer diagnosis, please fill out our Health Questionnaire so we can suggest the next steps you can take!"
      headerIcon={ListArrowIcon}
      headerSubText="To get started, we need some information from you."
      headerText="Answer Health Questionnaire"
      id="get-started-card"
      onActionClick={onActionClick}
    />
  );
};

export default GettingStartedHero;
